import { createClient } from '@supabase/supabase-js';
// import { SUPABASE_URL, SUPABASE_ANON_KEY } from '@env';
import { config } from './config';

// Use environment variables for Supabase configuration
const supabaseUrl = config.supabase.url;
const supabaseAnonKey = config.supabase.anonKey;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/**
 * Submit a contact form to the Supabase database
 * @param {Object} contactData - The contact form data
 * @param {string} contactData.name - Full name of the person
 * @param {string} contactData.email - Email address
 * @param {string} contactData.subject - Subject of the contact message
 * @param {string} contactData.message - The contact message content
 * @returns {Promise<Object>} - The result of the operation
 */
export const submitContactForm = async (contactData) => {
  try {
    // Validate required fields
    const { name, email, subject, message } = contactData;
    
    if (!name || !email || !subject || !message) {
      return {
        success: false,
        error: 'All fields are required'
      };
    }
    
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return {
        success: false,
        error: 'Please enter a valid email address'
      };
    }
    
    // Insert data into contact_submissions table
    const { data, error } = await supabase
      .from('contact_submissions')
      .insert([
        {
          name,
          email,
          subject,
          message,
          status: 'pending'
        }
      ])
      .select();
    
    if (error) {
      console.error('Error submitting contact form:', error);
      return {
        success: false,
        error: 'Failed to submit form. Please try again later.'
      };
    }
    
    return {
      success: true,
      data
    };
  } catch (error) {
    console.error('Exception submitting contact form:', error);
    return {
      success: false,
      error: 'An unexpected error occurred. Please try again later.'
    };
  }
};

/**
 * Join the waitlist by submitting email to the Supabase database
 * @param {Object} waitlistData - The waitlist submission data
 * @param {string} waitlistData.email - Email address (required)
 * @param {string} [waitlistData.name] - Name (optional)
 * @param {string} [waitlistData.referralSource] - How they found out about the service (optional)
 * @returns {Promise<Object>} - The result of the operation
 */
export const joinWaitlist = async (waitlistData) => {
  try {
    // Validate required email field
    const { email, name, referralSource } = waitlistData;
    
    if (!email) {
      return {
        success: false,
        error: 'Email address is required'
      };
    }
    
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return {
        success: false,
        error: 'Please enter a valid email address'
      };
    }
    
    // Insert data into waitlist table
    const { data, error } = await supabase
      .from('waitlist')
      .insert([
        {
          email,
          name: name || null,
          referral_source: referralSource || null,
          status: 'pending'
        }
      ])
      .select();
    
    if (error) {
      // Check for duplicate email (unique constraint violation)
      if (error.code === '23505') {
        return {
          success: false,
          error: 'This email is already on our waitlist'
        };
      }
      
      console.error('Error joining waitlist:', error);
      return {
        success: false,
        error: 'Failed to join waitlist. Please try again later.'
      };
    }
    
    return {
      success: true,
      data
    };
  } catch (error) {
    console.error('Exception joining waitlist:', error);
    return {
      success: false,
      error: 'An unexpected error occurred. Please try again later.'
    };
  }
};


//////////////////////////////////// ADMIN LOGIn//////////////////


export const adminLogin = async ({ username, password }) => {
  try {
    // Validate input
    if (!username || !password) {
      return {
        success: false,
        error: "Username and password are required"
      };
    }

    // Fetch admin user
    const { data, error } = await supabase
      .from("admin_users")
      .select("*")
      .eq("username", username)
      .single();

    if (error || !data) {
      return {
        success: false,
        error: "Invalid username or password"
      };
    }

    // Check password
    if (data.password !== password) {
      return {
        success: false,
        error: "Invalid username or password"
      };
    }

    return {
      success: true,
      user: {
        id: data.id,
        username: data.username,
        user_type: data.user_type
      }
    };

  } catch (error) {
    console.error("Admin login error:", error);

    return {
      success: false,
      error: "An unexpected error occurred"
    };
  }
};

////////////////////////////////////////////////////////Get all contact submissions (for admin dashboard)////////////////////


export const getAllContactSubmissions = async () => {
  try {

    const { data, error } = await supabase
      .from("contact_submissions")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Error fetching contact submissions:", error);

      return {
        success: false,
        error: "Failed to fetch contact submissions"
      };
    }

    return {
      success: true,
      data
    };

  } catch (error) {
    console.error("Exception fetching contact submissions:", error);

    return {
      success: false,
      error: "An unexpected error occurred"
    };
  }
};

///////////////////////////////////////////Get All Feed Back (form Mobile App)//////////////////////////////


export const getAllUserFeedback = async () => {
  try {

    const { data, error } = await supabase
      .from("user_feedback")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Error fetching feedback:", error);

      return {
        success: false,
        error: "Failed to fetch feedback"
      };
    }

    return {
      success: true,
      data
    };

  } catch (error) {
    console.error("Exception fetching feedback:", error);

    return {
      success: false,
      error: "An unexpected error occurred"
    };
  }
};


////////////////////////////////////////////////////////////////////////Waitlist Submissions (for admin dashboard)////////////////////

export const getAllWaitlistUsers = async () => {
  try {

    const { data, error } = await supabase
      .from("waitlist")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Error fetching waitlist:", error);

      return {
        success: false,
        error: "Failed to fetch waitlist users"
      };
    }

    return {
      success: true,
      data
    };

  } catch (error) {
    console.error("Exception fetching waitlist:", error);

    return {
      success: false,
      error: "An unexpected error occurred"
    };
  }
};